webpackJsonp([55142024454907],{

/***/ 378:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionByState = [{ state: 'receiveOrder', label: 'Receive order', event: 'order.received' }, { state: 'validateOrder', label: 'Order valid', event: 'order.valid', secondaryLabel: 'Order invalid', secondaryEvent: 'order.invalid' }, { state: 'checkInventory', label: 'Inventory available', event: 'inventory.available', secondaryLabel: 'Backorder', secondaryEvent: 'inventory.unavailable' }, { state: 'backorder', label: 'Inventory arrived', event: 'inventory.available', secondaryLabel: 'Customer cancels', secondaryEvent: 'customer.cancel' }, { state: 'authorizePayment', label: 'Payment approved', event: 'payment.approved', secondaryLabel: 'Payment declined', secondaryEvent: 'payment.declined' }, { state: 'pickAndPack', label: 'Package ready', event: 'package.ready' }, { state: 'shipOrder', label: 'Shipment sent', event: 'shipment.sent' }];
	
	var activeActions = function activeActions(configuration) {
	  var states = configuration || [];
	  return actionByState.filter(function (action) {
	    return states.indexOf(action.state) > -1;
	  });
	};
	
	var BusinessProcessPanel = function BusinessProcessPanel(_ref) {
	  var configuration = _ref.configuration,
	      datamodel = _ref.datamodel,
	      log = _ref.log,
	      onEvent = _ref.onEvent,
	      onReset = _ref.onReset;
	
	  var states = configuration || [];
	  var actions = activeActions(states);
	  var isComplete = states.indexOf('completed') > -1;
	  var isCancelled = states.indexOf('cancelled') > -1;
	  var orderStatus = datamodel && datamodel.orderStatus ? datamodel.orderStatus : 'loading';
	  var paymentStatus = datamodel && datamodel.paymentStatus ? datamodel.paymentStatus : 'not started';
	  var warehouseStatus = datamodel && datamodel.warehouseStatus ? datamodel.warehouseStatus : 'not started';
	
	  return _react2.default.createElement(
	    'div',
	    { style: { height: '100%', padding: '1rem', background: '#f7f7f7', overflow: 'auto' } },
	    _react2.default.createElement(
	      'div',
	      { style: { background: '#fff', border: '1px solid #ddd', padding: '1rem', marginBottom: '1rem' } },
	      _react2.default.createElement(
	        'div',
	        { style: { color: '#666', textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.08em' } },
	        'Process status'
	      ),
	      _react2.default.createElement(
	        'h3',
	        { style: { margin: '0.25rem 0' } },
	        isComplete ? 'completed' : isCancelled ? 'cancelled' : orderStatus
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        'Payment: ',
	        paymentStatus
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        'Warehouse: ',
	        warehouseStatus
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { marginBottom: '1rem' } },
	      actions.map(function (action) {
	        return _react2.default.createElement(
	          'div',
	          { key: action.state, style: { marginBottom: '0.5rem' } },
	          _react2.default.createElement(
	            'button',
	            { className: 'btn btn-primary', style: { marginRight: '0.5rem', marginBottom: '0.35rem' }, onClick: function onClick() {
	                return onEvent(action.event);
	              } },
	            action.label
	          ),
	          action.secondaryEvent && _react2.default.createElement(
	            'button',
	            { className: 'btn btn-secondary', style: { marginBottom: '0.35rem' }, onClick: function onClick() {
	                return onEvent(action.secondaryEvent);
	              } },
	            action.secondaryLabel
	          )
	        );
	      }),
	      _react2.default.createElement(
	        'button',
	        { className: 'btn btn-light', onClick: onReset },
	        'Reset'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { marginBottom: '1rem' } },
	      _react2.default.createElement(
	        'strong',
	        null,
	        'Active states'
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: { display: 'flex', flexWrap: 'wrap', marginTop: '0.5rem' } },
	        states.map(function (state) {
	          return _react2.default.createElement(
	            'span',
	            {
	              key: state,
	              style: {
	                background: '#fff',
	                border: '1px solid #ddd',
	                borderRadius: '2px',
	                padding: '0.25rem 0.45rem',
	                margin: '0 0.35rem 0.35rem 0',
	                fontFamily: 'monospace',
	                fontSize: '0.85rem'
	              }
	            },
	            state
	          );
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'strong',
	      null,
	      'Trace'
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { marginTop: '0.5rem', fontFamily: 'monospace', fontSize: '0.85rem' } },
	      (log || []).map(function (entry, index) {
	        return _react2.default.createElement(
	          'div',
	          { key: entry + '-' + index, style: { padding: '0.3rem 0', borderTop: index ? '1px solid #e2e2e2' : 0 } },
	          entry
	        );
	      })
	    )
	  );
	};
	
	exports.default = BusinessProcessPanel;
	module.exports = exports['default'];

/***/ }),

/***/ 379:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.businessProcessScxml = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _scxml = __webpack_require__(28);
	
	var _scxml2 = _interopRequireDefault(_scxml);
	
	var _schviz = __webpack_require__(13);
	
	var _schviz2 = _interopRequireDefault(_schviz);
	
	var _businessProcessPanel = __webpack_require__(378);
	
	var _businessProcessPanel2 = _interopRequireDefault(_businessProcessPanel);
	
	var _orderFulfillment = __webpack_require__(879);
	
	var _orderFulfillment2 = _interopRequireDefault(_orderFulfillment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	exports.businessProcessScxml = _orderFulfillment2.default;
	
	var BusinessProcessExample = function (_React$Component) {
	  _inherits(BusinessProcessExample, _React$Component);
	
	  function BusinessProcessExample(props) {
	    _classCallCheck(this, BusinessProcessExample);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = { log: [] };
	    return _this;
	  }
	
	  BusinessProcessExample.prototype.componentDidMount = function componentDidMount() {
	    this.start();
	  };
	
	  BusinessProcessExample.prototype.start = function start() {
	    var _this2 = this;
	
	    this.setState({ log: [] });
	
	    _scxml2.default.documentStringToModel(null, _orderFulfillment2.default, function (err, model) {
	      if (err) throw err;
	      model.prepare(function (err, modelFactory) {
	        if (err) throw err;
	
	        _this2.sc = new _scxml2.default.scion.Statechart(modelFactory, {
	          customSend: _this2.customSend.bind(_this2)
	        });
	
	        var transitionsEnabled = void 0;
	        _this2.sc.on('onBigStepBegin', function () {
	          transitionsEnabled = new Map();
	        });
	        _this2.sc.on('onBigStepEnd', function () {
	          var _sc$getSnapshot = _this2.sc.getSnapshot(),
	              _ = _sc$getSnapshot[0],
	              history = _sc$getSnapshot[1],
	              isInFinalState = _sc$getSnapshot[2],
	              datamodel = _sc$getSnapshot[3];
	
	          _this2.setState({
	            datamodel: datamodel,
	            configuration: _this2.sc.getFullConfiguration(),
	            transitionsEnabled: transitionsEnabled
	          });
	        });
	        _this2.sc.on('onTransition', function (transitionSourceId, targetIds, transitionIndex) {
	          if (transitionsEnabled.has(transitionSourceId)) {
	            transitionsEnabled.get(transitionSourceId).add(transitionIndex);
	          } else {
	            transitionsEnabled.set(transitionSourceId, new Set([transitionIndex]));
	          }
	        });
	        _this2.sc.start();
	      });
	    });
	  };
	
	  BusinessProcessExample.prototype.customSend = function customSend(event) {
	    if (event.name === 'trace') {
	      this.appendLog(event.data);
	    } else {
	      this.sc.gen(event);
	    }
	  };
	
	  BusinessProcessExample.prototype.appendLog = function appendLog(entry) {
	    if (!entry) return;
	    this.setState(function (_ref) {
	      var log = _ref.log;
	      return { log: log.concat(entry).slice(-12) };
	    });
	  };
	
	  BusinessProcessExample.prototype.send = function send(event) {
	    if (this.sc) this.sc.gen(event);
	  };
	
	  BusinessProcessExample.prototype.render = function render() {
	    var _this3 = this;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'row', style: { minHeight: '640px' } },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-8', style: { marginBottom: '1rem' } },
	        _react2.default.createElement(
	          'div',
	          { style: { height: '640px', width: '100%', position: 'relative', border: '1px solid #eee' } },
	          _react2.default.createElement(_schviz2.default, {
	            scxmlDocumentString: _orderFulfillment2.default,
	            disableAnimation: true,
	            disableZoom: true,
	            configuration: this.state && this.state.configuration,
	            disableZoomAnimation: true,
	            transitionsEnabled: this.state && this.state.transitionsEnabled,
	            expandAllStatesByDefault: true,
	            layoutOptions: _schviz2.default.layouts.auto,
	            id: 'business-process'
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-4', style: { marginBottom: '1rem' } },
	        _react2.default.createElement(
	          'div',
	          { style: { height: '640px', border: '1px solid #eee' } },
	          _react2.default.createElement(_businessProcessPanel2.default, {
	            configuration: this.state.configuration,
	            datamodel: this.state.datamodel,
	            log: this.state.log,
	            onEvent: function onEvent(event) {
	              return _this3.send(event);
	            },
	            onReset: function onReset() {
	              return _this3.start();
	            }
	          })
	        )
	      )
	    );
	  };
	
	  return BusinessProcessExample;
	}(_react2.default.Component);
	
	exports.default = BusinessProcessExample;

/***/ }),

/***/ 879:
/***/ (function(module, exports) {

	module.exports = "<scxml datamodel=\"ecmascript\"\n       initial=\"receiveOrder\"\n       name=\"OrderFulfillmentProcess\"\n       version=\"1.0\"\n       xmlns=\"http://www.w3.org/2005/07/scxml\">\n  <datamodel>\n    <data id=\"orderStatus\" expr=\"'waiting for order'\"/>\n    <data id=\"paymentStatus\" expr=\"'not started'\"/>\n    <data id=\"warehouseStatus\" expr=\"'not started'\"/>\n  </datamodel>\n\n  <state id=\"receiveOrder\">\n    <onentry>\n      <assign location=\"orderStatus\" expr=\"'waiting for order'\"/>\n      <send event=\"trace\"><content expr=\"'Start event: waiting for a customer order.'\"/></send>\n    </onentry>\n    <transition event=\"order.received\" target=\"validateOrder\">\n      <assign location=\"orderStatus\" expr=\"'received'\"/>\n    </transition>\n  </state>\n\n  <state id=\"validateOrder\">\n    <onentry>\n      <assign location=\"orderStatus\" expr=\"'validating order'\"/>\n      <send event=\"trace\"><content expr=\"'Activity: validate order.'\"/></send>\n    </onentry>\n    <transition event=\"order.valid\" target=\"checkInventory\"/>\n    <transition event=\"order.invalid\" target=\"cancelled\">\n      <assign location=\"orderStatus\" expr=\"'invalid order'\"/>\n    </transition>\n  </state>\n\n  <state id=\"checkInventory\">\n    <onentry>\n      <assign location=\"orderStatus\" expr=\"'checking inventory'\"/>\n      <send event=\"trace\"><content expr=\"'Exclusive gateway: inventory available?'\"/></send>\n    </onentry>\n    <transition event=\"inventory.available\" target=\"fulfillment\"/>\n    <transition event=\"inventory.unavailable\" target=\"backorder\"/>\n  </state>\n\n  <state id=\"backorder\">\n    <onentry>\n      <assign location=\"orderStatus\" expr=\"'backordered'\"/>\n      <send event=\"trace\"><content expr=\"'Waiting for inventory or customer cancellation.'\"/></send>\n    </onentry>\n    <transition event=\"inventory.available\" target=\"fulfillment\"/>\n    <transition event=\"customer.cancel\" target=\"cancelled\">\n      <assign location=\"orderStatus\" expr=\"'cancelled by customer'\"/>\n    </transition>\n  </state>\n\n  <parallel id=\"fulfillment\">\n    <onentry>\n      <assign location=\"orderStatus\" expr=\"'fulfilling order'\"/>\n      <assign location=\"paymentStatus\" expr=\"'authorizing'\"/>\n      <assign location=\"warehouseStatus\" expr=\"'picking and packing'\"/>\n      <send event=\"trace\"><content expr=\"'Parallel gateway: authorize payment and pick/pack order.'\"/></send>\n    </onentry>\n\n    <transition event=\"payment.declined\" target=\"cancelled\">\n      <assign location=\"paymentStatus\" expr=\"'declined'\"/>\n      <assign location=\"orderStatus\" expr=\"'payment declined'\"/>\n    </transition>\n\n    <state id=\"payment\" initial=\"authorizePayment\">\n      <state id=\"authorizePayment\">\n        <transition event=\"payment.approved\" target=\"paymentComplete\">\n          <assign location=\"paymentStatus\" expr=\"'approved'\"/>\n          <send event=\"trace\"><content expr=\"'Payment approved.'\"/></send>\n        </transition>\n      </state>\n      <final id=\"paymentComplete\"/>\n    </state>\n\n    <state id=\"warehouse\" initial=\"pickAndPack\">\n      <state id=\"pickAndPack\">\n        <transition event=\"package.ready\" target=\"warehouseComplete\">\n          <assign location=\"warehouseStatus\" expr=\"'package ready'\"/>\n          <send event=\"trace\"><content expr=\"'Package ready.'\"/></send>\n        </transition>\n      </state>\n      <final id=\"warehouseComplete\"/>\n    </state>\n  </parallel>\n\n  <transition event=\"done.state.fulfillment\" target=\"shipOrder\"/>\n\n  <state id=\"shipOrder\">\n    <onentry>\n      <assign location=\"orderStatus\" expr=\"'ready to ship'\"/>\n      <send event=\"trace\"><content expr=\"'Activity: ship order.'\"/></send>\n    </onentry>\n    <transition event=\"shipment.sent\" target=\"completed\">\n      <assign location=\"orderStatus\" expr=\"'shipped'\"/>\n    </transition>\n  </state>\n\n  <final id=\"completed\">\n    <onentry>\n      <assign location=\"orderStatus\" expr=\"'completed'\"/>\n      <send event=\"trace\"><content expr=\"'End event: order completed.'\"/></send>\n    </onentry>\n  </final>\n\n  <final id=\"cancelled\">\n    <onentry>\n      <send event=\"trace\"><content expr=\"'End event: order cancelled.'\"/></send>\n    </onentry>\n  </final>\n</scxml>\n"

/***/ }),

/***/ 427:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var React = _interopRequireWildcard(_react);
	
	var _prismjs = __webpack_require__(38);
	
	var _prismjs2 = _interopRequireDefault(_prismjs);
	
	var _reactPrism = __webpack_require__(22);
	
	var _reactPrism2 = _interopRequireDefault(_reactPrism);
	
	var _TutorialPageWrapper = __webpack_require__(18);
	
	var _TutorialPageWrapper2 = _interopRequireDefault(_TutorialPageWrapper);
	
	var _businessProcessExample = __webpack_require__(379);
	
	var _businessProcessExample2 = _interopRequireDefault(_businessProcessExample);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var BusinessProcess = function BusinessProcess(_ref) {
	  var sectionName = _ref.sectionName,
	      by = _ref.by;
	  return React.createElement(
	    'div',
	    null,
	    React.createElement(
	      'h1',
	      null,
	      sectionName
	    ),
	    React.createElement(
	      'h6',
	      null,
	      by
	    ),
	    React.createElement(
	      'p',
	      null,
	      'This is a BPMN-style order fulfillment process modeled in SCXML. It uses event, activity, gateway, and parallel-flow concepts from Business Process Model and Notation, then makes the flow executable in SCION.'
	    ),
	    React.createElement(_businessProcessExample2.default, null),
	    React.createElement(
	      'h2',
	      null,
	      'SCXML source'
	    ),
	    React.createElement(
	      _reactPrism2.default,
	      { component: 'pre', className: 'language-xml' },
	      _businessProcessExample.businessProcessScxml
	    )
	  );
	};
	
	var WrappedBusinessProcess = function WrappedBusinessProcess(_ref2) {
	  var location = _ref2.location;
	  return React.createElement(_TutorialPageWrapper2.default, { Component: BusinessProcess, pathname: location.pathname });
	};
	
	exports.default = WrappedBusinessProcess;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-tutorials-examples-business-process-js-791b9f47217256663830.js